import "./search-upload-by.scss";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import NOT_FOUND_ICON from "../../assets/images/not-found.svg";

const SearchUploadByModal = ({ show, userList, selectedUploadBy, onClose }) => {

    const [value, setValue] = useState('');
    const [uploadByList, setUploadByList] = useState<any>([]);
    const [isSearchNotFound, setIsSearchNotFound] = useState<boolean>(false);

    useEffect(() => {
        if (userList) {
            const tempValue = userList.map(item => ({
                value: item,
                checked: selectedUploadBy.includes(item) ? true : false,
                hidden: false
            }));
            setUploadByList(tempValue)
        }
    }, [userList]);

    useEffect(() => {
        handleSearch(value);
    }, [value]);

    useEffect(() => {
        setIsSearchNotFound(!Boolean(uploadByList.find(item => !item.hidden)));
    }, [uploadByList]);

    const handleClose = () => {
        onClose(false);
    }

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const clearInput = () => {
        setValue('');
    };

    const clearAll = () => {
        clearInput();
        setUploadByList(prev => prev.map(item => ({ ...item, checked: false })));
    };

    const handleSearch = (searchValue: string) => {
        setUploadByList((prev) => {
            return prev.map(item => {
                if (item.value.toLowerCase().includes(searchValue.toLowerCase())) {
                    item.hidden = false;
                } else {
                    item.hidden = true;
                }
                return item;
            })
        })
    }

    const handleCheckboxChange = (value: string, checked: boolean) => {
        setUploadByList(prev => {
            const updatedList = prev.map(item =>
                item.value === value ? { ...item, checked } : item
            );
            return updatedList;
        });
    };

    const handleSubmit = () => {
        const tempValue = uploadByList.filter(item => item.checked === true).map(item => item.value);
        onClose(tempValue);
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="search-upload-by-modal">
            <Modal.Body className='search-upload-by-modal-wrapper'>
                <FontAwesomeIcon icon={faClose} className="modal-icon-close" onClick={handleClose}></FontAwesomeIcon>

                <div className="search-upload-by-modal-search-wrapper">

                    <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-upload-by">ผู้อัปโหลด</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-upload-by"
                            type="text"
                            value={value}
                            onChange={handleChange}
                            endAdornment={
                                value &&
                                <InputAdornment position="end">
                                    <IconButton edge="end" onClick={clearInput}>
                                        <CloseIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="ผู้อัปโหลด"
                        />
                    </FormControl>

                    <Button
                        variant="outlined"
                        className="search-upload-by-modal-clear"
                        onClick={clearAll}
                    >
                        ล้างข้อมูล
                    </Button>
                </div>

                {
                    isSearchNotFound ?
                        <div className="search-upload-by-modal-item-wrapper d-flex flex-column justify-content-center align-items-center">
                            <img src={NOT_FOUND_ICON} width={50} height={50} className="mb-3" />
                            <span>ไม่พบรายการที่คุณค้นหา</span>
                        </div> :
                        <div className="search-upload-by-modal-item-wrapper">
                            {
                                uploadByList && uploadByList.filter(item => !item.hidden).map((item, index) => (
                                    <div key={index} className="search-upload-by-modal-item">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={item.checked}
                                                    onChange={(event) => handleCheckboxChange(item.value, event.target.checked)}
                                                />}
                                            label={item.value}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                }

                <Button
                    variant="contained"
                    className="search-upload-by-modal-search-button"
                    onClick={handleSubmit}
                >
                    ค้นหา
                </Button>
            </Modal.Body>
        </Modal>
    )
}

export default SearchUploadByModal;